// Available avatar asset paths for local bots
export const BOT_AVATARS = new Array(55)
  .fill(null)
  .map((_, index) => `assets/avatars/${index + 1}.png`);
